module.exports = __webpack_public_path__ + "static/moonlitNightMoreModern1Arranged-74d261b46c76b34a11bf9442cf08c81f.mp3";